(function() {
    // Main function to check cart and handle checkout visibility
    function checkCartMetafields() {
      console.log('Checking cart metafields...');
      
      // Get all cart items
      const cartItems = document.querySelectorAll('.cart-item, .cart__item, .cart-items > tr, [data-cart-item]');
      
      console.log(`Found ${cartItems.length} cart items`);
      
      if (cartItems.length === 0) {
        console.log('No cart items found, showing checkout button');
        showCheckoutButton();
        return;
      }
      
      let processedItems = 0;
      const totalItems = cartItems.length;
      
      // Track tag presence
      const allTagsInCart = new Set();
      
      // First pass: collect product tags
      cartItems.forEach(item => {
        // Find product URL
        const productLink = item.querySelector('a[href*="/products/"]');
        
        if (!productLink) {
          console.log('No product link found for item');
          processedItems++;
          if (processedItems >= totalItems) {
            evaluateRules();
          }
          return;
        }
        
        const productUrl = productLink.getAttribute('href');
        const urlParts = productUrl.split('/products/');
        
        if (urlParts.length < 2) {
          console.log('Invalid product URL:', productUrl);
          processedItems++;
          if (processedItems >= totalItems) {
            evaluateRules();
          }
          return;
        }
        
        // Extract product handle
        let productHandle = urlParts[1].split('?')[0].split('#')[0];
        if (productHandle.endsWith('/')) {
          productHandle = productHandle.slice(0, -1);
        }
        
        console.log('Processing product:', productHandle);
        
        // Fetch product data to get tags
        fetch(`/products/${productHandle}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then(productData => {
            const tags = Array.isArray(productData.tags) ? productData.tags : productData.tags.split(', ');
            console.log('Product tags:', tags);
            
            // Store tags in the product-tags div
            const tagsDiv = item.querySelector('.product-tags');
            if (tagsDiv) {
              tagsDiv.textContent = tags.join(', ');
              
              // Add tags to data attribute as well for redundancy
              item.setAttribute('data-product-tags', tags.join(', '));
            }
            
            // Add tags to our collection
            tags.forEach(tag => {
              if (tag) allTagsInCart.add(tag);
            });
            
            // Increment processed items count
            processedItems++;
            
            // Once all items are processed, evaluate rules
            if (processedItems >= totalItems) {
              evaluateRules();
            }
          })
          .catch(error => {
            console.error('Error fetching product data:', error);
            
            // Increment processed items count even on error
            processedItems++;
            
            // Once all items are processed, evaluate rules
            if (processedItems >= totalItems) {
              evaluateRules();
            }
          });
      });
      
      // Function to evaluate rules after all tags are collected
      function evaluateRules() {
        // Track items with unless.tag metafields
        const itemsWithUnlessTags = [];
        
        // Find items with unless.tag metafields
        cartItems.forEach(item => {
          // Get unless.tag metafield value
          let unlessTag = null;
          
          // Try different methods to get the unless.tag value
          const unlessTagSpan = item.querySelector('.unless-tag, .metafield-unless-tag');
          if (unlessTagSpan && unlessTagSpan.textContent.trim()) {
            unlessTag = unlessTagSpan.textContent.trim();
          }
          
          const metafieldAttr = item.querySelector('[data-metafield-unless-tag]');
          if (metafieldAttr && metafieldAttr.getAttribute('data-metafield-unless-tag')) {
            unlessTag = metafieldAttr.getAttribute('data-metafield-unless-tag').trim();
          }
          
          // If this item has an unless.tag, store it for evaluation
          if (unlessTag) {
            const productTitle = item.querySelector('a.cart-item__name, a[href*="/products/"]');
            const title = productTitle ? productTitle.textContent.trim() : 'Unknown Product';
            
            itemsWithUnlessTags.push({
              unlessTag: unlessTag,
              title: title,
              domElement: item
            });
          }
        });
        
        console.log('All tags in cart:', Array.from(allTagsInCart));
        console.log('Items with unless.tag metafields:', itemsWithUnlessTags);
        
        // If no items have unless.tag metafields, show the checkout button
        if (itemsWithUnlessTags.length === 0) {
          console.log('No items have unless.tag metafields, showing checkout button');
          showCheckoutButton();
          return;
        }
        
        // Check each item with an unless.tag
        let shouldHideCheckout = false;
        
        for (const item of itemsWithUnlessTags) {
          console.log(`Checking if any item has the tag "${item.unlessTag}" specified in unless.tag for "${item.title}"`);
          
          // Check if ANY item in the cart has the tag specified in unless.tag
          const anyItemHasTag = allTagsInCart.has(item.unlessTag);
          
          if (!anyItemHasTag) {
            console.log(`No item has the tag "${item.unlessTag}", so checkout should be hidden`);
            shouldHideCheckout = true;
            
            // Add warning message to this item
            addWarningMessage(item.domElement, `Dit product kan je alleen op offerte aanvragen.`);
          } else {
            console.log(`Found item with tag "${item.unlessTag}", so checkout can be shown`);
          }
        }
        
        // Apply checkout visibility
        if (shouldHideCheckout) {
          hideCheckoutButton();
        } else {
          showCheckoutButton();
        }
      }
    }
    
    // Helper function to add warning message to cart item
    function addWarningMessage(itemElement, warningText) {
      const detailsContainer = itemElement.querySelector('.cart-item__details, .cart-info, .cart__item-details, .cart__item-name');
      
      if (detailsContainer) {
        // Check if warning already exists
        if (!detailsContainer.querySelector('.hide-checkout-warning')) {
          const warningMessage = document.createElement('p');
          warningMessage.className = 'hide-checkout-warning caption-with-letter-spacing';
          warningMessage.style.color = '#856404';
          warningMessage.style.marginTop = '5px';
          warningMessage.textContent = warningText;
          
          // Try different selectors for product title
          const productTitle = 
            detailsContainer.querySelector('a.cart-item__name') || 
            detailsContainer.querySelector('a[href*="/products/"]') ||
            detailsContainer.querySelector('.cart__item-title');
          
          if (productTitle) {
            productTitle.after(warningMessage);
          } else {
            detailsContainer.appendChild(warningMessage);
          }
        }
      }
    }
  
    // Helper function to hide checkout button
    function hideCheckoutButton() {
      console.log('Hiding checkout button');
      // Find checkout button using various common selectors
      const checkoutButtonSelectors = [
        'form[action*="/cart"] button[name="checkout"]',
        'form#cart button[name="checkout"]',
        '.cart__checkout',
        '#checkout',
        '[data-checkout-button]',
        'button[type="submit"][name="checkout"]',
        'input[type="submit"][name="checkout"]',
        '.cart-checkout',
        '.cart__footer button[name="checkout"]',
        '.cart__footer input[name="checkout"]'
      ];
      
      // Try each selector
      for (const selector of checkoutButtonSelectors) {
        const buttons = document.querySelectorAll(selector);
        if (buttons.length > 0) {
          buttons.forEach(button => {
            button.style.display = 'none';
          });
        }
      }
    }
  
    // Helper function to show checkout button
    function showCheckoutButton() {
      console.log('Showing checkout button');
      // Find checkout button using various common selectors
      const checkoutButtonSelectors = [
        'form[action*="/cart"] button[name="checkout"]',
        'form#cart button[name="checkout"]',
        '.cart__checkout',
        '#checkout',
        '[data-checkout-button]',
        'button[type="submit"][name="checkout"]',
        'input[type="submit"][name="checkout"]',
        '.cart-checkout',
        '.cart__footer button[name="checkout"]',
        '.cart__footer input[name="checkout"]'
      ];
      
      // Try each selector
      for (const selector of checkoutButtonSelectors) {
        const buttons = document.querySelectorAll(selector);
        if (buttons.length > 0) {
          buttons.forEach(button => {
            button.style.display = '';
          });
        }
      }
    }
    
    // Function to detect form submissions and AJAX requests
    function interceptFormSubmissionsAndAjaxRequests() {
      // Intercept form submissions
      const forms = document.querySelectorAll('form');
      forms.forEach(form => {
        form.addEventListener('submit', function(event) {
          const isCartForm = form.action.includes('/cart') || 
                            form.getAttribute('action').includes('/cart');
          
          if (isCartForm) {
            console.log('Cart form submitted, will recheck after submission');
            setTimeout(checkCartMetafields, 1000);
          }
        });
      });
      
      // Intercept AJAX requests
      const originalFetch = window.fetch;
      window.fetch = function(url, options) {
        const promise = originalFetch.apply(this, arguments);
        
        // Check if this is a cart-related request
        if (typeof url === 'string' && 
            (url.includes('/cart/add') || 
             url.includes('/cart/update') || 
             url.includes('/cart/change') || 
             url.includes('/cart/clear') ||
             url.includes('/cart/remove'))) {
          
          console.log('Cart AJAX request detected:', url);
          
          promise.then(() => {
            console.log('Cart AJAX request completed, rechecking cart');
            setTimeout(checkCartMetafields, 1000);
          });
        }
        
        return promise;
      };
      
      // Intercept XMLHttpRequest
      const originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function(method, url) {
        if (typeof url === 'string' && 
            (url.includes('/cart/add') || 
             url.includes('/cart/update') || 
             url.includes('/cart/change') || 
             url.includes('/cart/clear') ||
             url.includes('/cart/remove'))) {
          
          console.log('Cart XHR request detected:', url);
          
          const originalOnReadyStateChange = this.onreadystatechange;
          this.onreadystatechange = function() {
            if (this.readyState === 4) {
              console.log('Cart XHR request completed, rechecking cart');
              setTimeout(checkCartMetafields, 1000);
            }
            
            if (originalOnReadyStateChange) {
              originalOnReadyStateChange.apply(this, arguments);
            }
          };
        }
        
        return originalOpen.apply(this, arguments);
      };
    }
    
    // Setup event listeners and observers
    function init() {
      console.log('Cart Metafield Checker initializing...');
      
      // Run initial check
      setTimeout(checkCartMetafields, 300);
      
      // Listen for all possible cart events
      const cartEvents = [
        'cart.requestComplete', 
        'theme:cart:change', 
        'ajaxCart.afterCartLoad', 
        'cart:refresh', 
        'cart_update',
        'drawer:open',
        'cart:updated',
        'cart:change',
        'change',
        'update'
      ];
      
      cartEvents.forEach(event => {
        document.addEventListener(event, () => {
          console.log(`Event: ${event}`);
          setTimeout(checkCartMetafields, 500);
        });
      });
      
      // Add click event listeners specifically for all remove buttons and quantity inputs
      document.addEventListener('click', function(event) {
        // Target all possible remove button selectors
        const isRemoveButton = 
          event.target.matches('.cart__remove, .cart-item__remove, [data-cart-remove], .remove-item, .remove, .cart-remove, .js-remove-button, [data-remove-item]') ||
          event.target.closest('.cart__remove, .cart-item__remove, [data-cart-remove], .remove-item, .remove, .cart-remove, .js-remove-button, [data-remove-item]');
        
        // Target all possible quantity input selectors
        const isQuantityInput = 
          event.target.matches('[data-quantity-input], .js-qty__adjust, [data-qty-input], .quantity-selector') ||
          event.target.closest('[data-quantity-input], .js-qty__adjust, [data-qty-input], .quantity-selector');
        
        if (isRemoveButton) {
          console.log('Remove button clicked');
          setTimeout(checkCartMetafields, 1000);
        } else if (isQuantityInput) {
          console.log('Quantity input changed');
          setTimeout(checkCartMetafields, 1000);
        }
      });
      
      // Watch for changes to the quantity inputs
      document.addEventListener('change', function(event) {
        const isQuantityInput = 
          event.target.matches('[name^="updates"], [name="quantity"], [data-quantity-input], [data-qty-input], .quantity-selector') ||
          event.target.closest('[name^="updates"], [name="quantity"], [data-quantity-input], [data-qty-input], .quantity-selector');
        
        if (isQuantityInput) {
          console.log('Quantity input value changed');
          setTimeout(checkCartMetafields, 1000);
        }
      });
      
      // Setup a MutationObserver to detect changes to the cart
      const cartObserver = new MutationObserver(function(mutations) {
        let cartChanged = false;
        
        mutations.forEach(mutation => {
          // Check for removed nodes (items being deleted)
          if (mutation.removedNodes && mutation.removedNodes.length > 0) {
            for (let i = 0; i < mutation.removedNodes.length; i++) {
              const node = mutation.removedNodes[i];
              // If it's an element node, check if it might be a cart item
              if (node.nodeType === 1) {
                if (
                  node.classList && 
                  (node.classList.contains('cart-item') || 
                   node.classList.contains('cart__item') ||
                   node.classList.contains('cart__row'))
                ) {
                  console.log('Cart item removed');
                  cartChanged = true;
                  break;
                }
                
                // Also check if it contains cart items
                if (node.querySelector && 
                    node.querySelector('.cart-item, .cart__item, .cart__row')) {
                  console.log('Element containing cart items removed');
                  cartChanged = true;
                  break;
                }
              }
            }
          }
          
          // Check for added nodes (items being added)
          if (!cartChanged && mutation.addedNodes && mutation.addedNodes.length > 0) {
            for (let i = 0; i < mutation.addedNodes.length; i++) {
              const node = mutation.addedNodes[i];
              // If it's an element node, check if it might be a cart item
              if (node.nodeType === 1) {
                if (
                  node.classList && 
                  (node.classList.contains('cart-item') || 
                   node.classList.contains('cart__item') ||
                   node.classList.contains('cart__row'))
                ) {
                  console.log('Cart item added');
                  cartChanged = true;
                  break;
                }
                
                // Also check if it contains cart items
                if (node.querySelector && 
                    node.querySelector('.cart-item, .cart__item, .cart__row')) {
                  console.log('Element containing cart items added');
                  cartChanged = true;
                  break;
                }
              }
            }
          }
          
          // Check if the mutation affected cart-related elements
          if (!cartChanged && mutation.target.classList) {
            if (
              mutation.target.classList.contains('cart') || 
              mutation.target.closest('.cart') || 
              mutation.target.closest('[data-cart]') ||
              mutation.target.closest('.cart-drawer') ||
              mutation.target.closest('.mini-cart')
            ) {
              console.log('Cart-related element modified');
              cartChanged = true;
            }
          }
        });
        
        if (cartChanged) {
          console.log('Cart change detected by MutationObserver');
          setTimeout(checkCartMetafields, 500);
        }
      });
      
      // Start observing
      cartObserver.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'data-cart-item-key']
      });
      
      // Intercept form submissions and AJAX requests
      interceptFormSubmissionsAndAjaxRequests();
      
      console.log('Cart Metafield Checker initialized');
    }
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();